import DOMPurify from "dompurify";

export const domSanitize = (html?: string | null): string => (html ? DOMPurify.sanitize(html) : "");
